import type { GeometryDataTyped } from "@/types/blocks.types";
import {
  ParametricAssetId,
  SubmittingOrganization,
  type ParametricAsset,
} from "@/types";

type AssetParams = {
  L: number;
  ld: number;
  lg: number;
  e: number;
  p: number;
  n: number;
  b: number;
};

const asset: ParametricAsset<AssetParams> = {
  id: ParametricAssetId.BEAM_BRIDGE,
  image: "/images/assets/pont-à-poutres.png",
  submittedBy: SubmittingOrganization.SITES,
  inputs: [
    {
      key: "p",
      type: "dimension",
    },
    {
      key: "n",
      type: "quantity",
    },
    {
      key: "L",
      type: "dimension",
    },
    {
      key: "ld",
      type: "dimension",
    },
    {
      key: "lg",
      type: "dimension",
    },
    {
      key: "e",
      type: "dimension",
    },

    {
      key: "b",
      type: "angle",
    },
  ],
  build: (params, offset) => {
    const { ld, lg, e, b, n, p, L } = params;
    const bRad = (b * Math.PI) / 180;

    const hyp = (value: number) => value / Math.sin(bRad);

    const width = hyp(ld) + hyp(lg) + (n - 1) * hyp(e) + n * hyp(p);
    const height = L * Math.sin(bRad);
    const delta = (L ** 2 - height ** 2) ** 0.5;

    const res: GeometryDataTyped[] = [
      {
        type: "polyline",
        points: [
          [offset[0], offset[1], offset[2]],
          [offset[0] + width, offset[1], offset[2]],
          [offset[0] + width + delta, offset[1] + height, offset[2]],
          [offset[0] + delta, offset[1] + height, offset[2]],
          [offset[0], offset[1], offset[2]],
        ],
      },
    ];

    for (let i = 0; i < n; i++) {
      const startX = offset[0] + hyp(lg) + i * (hyp(e) + hyp(p));
      res.push({
        type: "polyline",
        points: [
          [startX, offset[1], offset[2]],
          [startX + hyp(p), offset[1], offset[2]],
          [startX + hyp(p) + delta, offset[1] + height, offset[2]],
          [startX + delta, offset[1] + height, offset[2]],
          [startX, offset[1], offset[2]],
        ],
      });
    }

    return res;
  },
};

export default asset;
